import mitt from 'mitt'
export const globalEventBus = mitt()
export const globalEvents = {
  sidebarChanged: 'de.custom-media.signdigital.sidebar-changed',
  contentAreaChanged: 'de.custom-media.signdigital.content-area-changed',
  actionsDropdown: 'de.custom-media.signdigital.actions-dropdown'
}
